import { Card, Table } from 'antd';
import React from 'react';

const DashboardTableCustomers = ({ t, dataCustomers }) => {
  const columns = [
    {
      title: t.customerName,
      dataIndex: 'customer_name',
      key: 'customer_name',
    },

    {
      title: t.CountSalesOrder,
      dataIndex: 'total_sales_order_count',
      key: 'total_sales_order_count',
    },
    {
      title: t.grandTotal,
      dataIndex: 'grand_total',
      key: 'grand_total',
      render: (text) => (
        <div className="flex items-center gap-1">
          {text}
          <span className="text-[10px] font-[400] text-[#878a99]">{t.SAR}</span>
        </div>
      ),
    },
  ];
  return (
    <>
      <Card
        style={{ height: '100%' }}
        styles={{
          body: {
            height: '100%',
          },
        }}
        title={t.topCustomers}
      >
        <Table
                className="table_custom"
          // showHeader={false}
          columns={columns}
          pagination={{
            hideOnSinglePage: true,
          }}
          dataSource={dataCustomers?.map((item) => ({ ...item, key: item.id }))}
          scroll={{ x: 'max-content' }}
        />
      </Card>
    </>
  );
};

export default DashboardTableCustomers;
